export default __webpack_public_path__ + "static/media/location-pin.298fc6e3.svg";